import { render } from "./NewLocationFullCard.vue?vue&type=template&id=74312c0d"
import script from "./NewLocationFullCard.vue?vue&type=script&lang=js"
export * from "./NewLocationFullCard.vue?vue&type=script&lang=js"

import "./NewLocationFullCard.vue?vue&type=style&index=0&id=74312c0d&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__